// Small status pill used for product availability.
const styles = {
  Available: 'bg-emerald-500/10 text-emerald-300 ring-emerald-400/20',
  Beta: 'bg-amber-500/10 text-amber-300 ring-amber-400/20',
  'Coming soon': 'bg-slate-500/10 text-slate-300 ring-slate-400/20',
}

export default function Badge({ status }) {
  const cls = styles[status] || styles['Coming soon']
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-1 text-xs font-semibold ring-1 ${cls}`}>
      {status}
    </span>
  )
}
